import { Link } from 'react-router-dom';
import { SettingsTabs } from '../components/SettingsTabs';
import { LevelerSettings } from '../components/LevelerSettings';

/**
 * Tutta la configurazione della livella su un indirizzo suo. Serve raramente —
 * si compila una volta e poi si guarda solo la taratura — quindi stava stretta
 * in fondo alle impostazioni dell'app, dove per arrivarci si scorreva tutto.
 */
export function LevelerSettingsPage() {
  return (
    <div className="page">
      <div className="page-head">
        <div className="title-block">
          <h1>Impostazioni</h1>
        </div>
      </div>

      <SettingsTabs />

      <LevelerSettings />

      <p className="muted">
        Per livellare il camper vai su <Link to="/livella">Livella</Link>.
      </p>
    </div>
  );
}
